import { z } from 'zod';

import { ContentFreePageviewDimensionsSchema } from './dimensions';

/** Staff identity is intentional; registered chat content and arbitrary person properties are not. */
const ContentFreeStaffPersonPropertiesSchema = z.object({
  email: z.email().optional().catch(undefined),
  name: z.string().optional().catch(undefined),
  defaultOrganizationId: z.uuid().optional().catch(undefined),
  defaultOrganizationName: z.string().optional().catch(undefined),
  $initial_current_url: ContentFreePageviewDimensionsSchema.shape.$current_url,
  $initial_pathname: ContentFreePageviewDimensionsSchema.shape.$pathname,
  $initial_referrer: ContentFreePageviewDimensionsSchema.shape.$referrer,
  $initial_referring_domain: ContentFreePageviewDimensionsSchema.shape.$referring_domain,
});

export const ContentFreeStaffPersonSettersSchema = z.object({
  $set: ContentFreeStaffPersonPropertiesSchema.optional().catch(undefined),
  $set_once: ContentFreeStaffPersonPropertiesSchema.optional().catch(undefined),
});
